define('css-auto-reload',['socket'], function (socket) {
	socket.on('css-reload:success', function () {
		$('#css-compilation-status').hide();

		var styleSheets = document.styleSheets;

		for (var i = 0, l = styleSheets.length; i < l; i++) {
			var styleSheet = styleSheets[i],
				href = styleSheet.href;

			// exclude embedded stylesheets
			if (!href) {
				return;
			}

			var styleSheetNode = styleSheet.ownerNode;
			if (styleSheetNode._removalPending) {
				continue;
			}
			styleSheetNode._removalPending = true;

			var versionParameter = 'version=' + Date.now();
			if (href.indexOf('version=') >= 0) {
				href = href.replace(/version=\d+/, versionParameter);
			} else {
				if (href.indexOf('?') < 0) {
					href += '?';
				} else {
					href += '&';
				}
				href += versionParameter;
			}

			var clonedStyleSheetNode = styleSheetNode.cloneNode(false);
			clonedStyleSheetNode.href = href;

			var parentNode = styleSheetNode.parentNode;
			parentNode.appendChild(clonedStyleSheetNode);

			setRemovalTimeout(parentNode, styleSheetNode);
		}
	});

	function setRemovalTimeout(parentNode, styleSheetNode) {
		setTimeout(function () {
			parentNode.removeChild(styleSheetNode);
		}, 200);
	}

	socket.on('css-reload:error', function (message) {
		var messageField = $('#css-compilation-status');
		if (messageField.length < 1) {
			messageField = $('<div>').attr('id', 'css-compilation-status').appendTo('body');
		}
		messageField.show().text(message);
	});
});

